import React from "react";
import "./loader.scss"

export default function Loader (props) {
  return <div className={`loader ${props.className}`} style={{width: props.width, height: props.height}}/>
}